export default {"src":"/_next/static/media/hive-logo.cd954a85.svg","height":190,"width":220,"blurWidth":0,"blurHeight":0};